import './CSS/team.css'

import mazzpfp from "./assets/mazzpfp.png"
import redpfp from "./assets/redpfp.png"
import pinkpfp from "./assets/pinkpfp.png"
import paulinkpfp from "./assets/pkpfp.png"

import AnimatedPage from './animatedPage'

import { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function Team({ isMobile }) {

    const whichLayout = isMobile ? 'profileSectionMobile' : 'profileSection'

    const fadeIn = [0, 0.035, 0.07, 0.105, 0.14]
    const fadeOut = [0.14, 0.105, 0.07, 0.035, 0]

    const whichFade = useRef(fadeIn)
    const location = useLocation()
    useEffect(() => {
        whichFade.current = (location.pathname === '/team') ? fadeOut : fadeIn
    }, [])
    const delay = whichFade.current

    return (

        <div className='teamPageContainer'>

            <AnimatedPage delay={delay[0]}>
                <h1>Team</h1>
            </AnimatedPage>

            <div className='profilesContainer'>

                {/* <AnimatedPage delay={delay[1]}>
                    <div className={whichLayout}>
                        <div className='pfpContainer'><img src={pinkpfp} className='pfp' alt='Pink PFP' /></div>
                        <div className='blurbContainer'>
                            <p><strong>Pink</strong><br />
                                <strong>Professional scammer</strong><br />
                                Stole 28 Eth of project funds then stopped contributing to the project</p>
                        </div>
                    </div>
                </AnimatedPage> */}

                <AnimatedPage delay={delay[2]}>
                    <div className={whichLayout}>
                        <div className='pfpContainer'><img src={paulinkpfp} className='pfp' alt='Paulinka PFP' /></div>
                        <div className='blurbContainer'>
                            <p><strong>Paulinka</strong><br />
                                <strong>Artist</strong><br />
                                Artist and designer inspired by everything cute and playful to create fun and accessible art</p>
                        </div>
                    </div>
                </AnimatedPage>

                <AnimatedPage delay={delay[3]}>
                    <div className={whichLayout}>
                        <div className='pfpContainer'><img src={mazzpfp} className='pfp' alt='Paulinka PFP' /></div>
                        <div className='blurbContainer'>
                            <p><strong>Mazzomes_Clone</strong><br />
                                <strong>Web3 Developer</strong><br />
                                Front and back end, building UI/UX for Web3: Mechatronics Engineer turned Web3 Software Engineer</p>
                        </div>
                    </div>
                </AnimatedPage>

                <AnimatedPage delay={delay[4]}>
                    <div className={whichLayout}>
                        <div className='pfpContainer'><img src={redpfp} className='pfp' alt='Paulinka PFP' /></div>
                        <div className='blurbContainer'>
                            <p><strong>RedM3</strong><br />
                                <strong>Blockchain Developer</strong><br />
                                Building out smart contracts and NFT generation: Mechatronics Engineer turned Blockchain Software Engineer</p>
                        </div>
                    </div>
                </AnimatedPage>

            </div>

        </div>

    )
}